import { render } from "./member-form.component.vue?vue&type=template&id=00cecbb3&scoped=true&ts=true"
import script from "./member-form.component.ts?vue&type=script&lang=ts"
export * from "./member-form.component.ts?vue&type=script&lang=ts"

import "./member-form.component.vue?vue&type=style&index=0&id=00cecbb3&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cecbb3"]])

export default __exports__